import Vue, { DirectiveOptions } from 'vue';
import Waiting from './Waiting.vue';

const LoadingComponent = Vue.extend(Waiting);

declare module 'vue/types/vue' {
    interface Vue {
      isLoading: string,
      statement: string
    }
  }

const retry = function () {
  window.location.reload();
};
let __loadingDom: HTMLDivElement, __loading: Vue;
const loading: DirectiveOptions = {

  bind (el, binding) {
    __loadingDom = document.createElement('div');
    const modifiers = binding.modifiers;
    __loading = new LoadingComponent({
      propsData: {
        isLoading: binding.value.isLoading,
        center: !!modifiers.center,
        transparent: !!modifiers.transparent,
        full: !!modifiers.full,
        statement: binding.value.statement,
      },
    });
  },
  inserted (el, binding, vnode) {
    let retryFun = retry;
    let elPos = window.getComputedStyle(el);
    const { position } = elPos;
    if (position !== 'fixed' && position !== 'absolute' && position !== 'relative') {
      el.style.position = 'relative';
    }
    el.appendChild(__loadingDom);
    __loading.$mount(__loadingDom);
    __loading.$on('fail', retryFun);
  },
  componentUpdated (el, binding) {
    if (__loading) {
      __loading.isLoading = binding.value.isLoading;
      __loading.statement = binding.value.statement;
    }
  },
  unbind () {
    if (__loading) {
      __loading.$destroy();
    }
  },
};

export default loading;
